import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { ListItemCriticalTextButton } from '$common/buttons/list-item-critical-text-button'
import { SettingsSection } from '$common/settings-section'
import { SettingsNotifs } from './settings-notifs'
import { SettingsPrivacy } from './settings-privacy'
import { SettingsStorage } from './settings-storage'
import { SettingsSecurity } from './settings-security'

import { t } from '$i18n'
import { closeSettings } from '$logic/router'
import { showDeleteAccountModal } from '$comp/modals/confirmation-dialog'
import { SettingLanguage } from './setings-language'

export function Settings() {
  return (
    <PageWithAppBar
      rootSx={{ textAlign: 'right' }}
      appBar={
        <AppBarBackTitle title={t('settings.title')} onBack={closeSettings} />
      }
    >
      <SettingsNotifs />
      <SettingsPrivacy />
      <SettingsStorage />
      <SettingsSecurity />
      <SettingLanguage />

      <SettingsSection>
        <ListItemCriticalTextButton
          text={t('settings.deleteAccount')}
          onClick={showDeleteAccountModal}
        />
      </SettingsSection>
    </PageWithAppBar>
  )
}
